// extracted by mini-css-extract-plugin
export var container = "fh_l";
export var fadeDiv = "fh_jz";
export var placeholderWrapper = "fh_tx";
export var video = "fh_qF";
export var videoWrapper = "fh_mJ";
export var vimeoPlayer = "fh_ty";
export var wrapper = "fh_C";